// extracted by mini-css-extract-plugin
export default {"investmentsList":"InvestmentsList_investmentsList__6aV3D"};